export default __webpack_public_path__ + "static/media/kitchen3-afterC-480w.c0c62976.webp";